import $ from 'jquery';
import * as parsley from '@elements/parsley-bootstrap-validation';

const VUE_SUBMITTED_FORMS = '.js-checkout-one-page-contact-form, .js-checkout-one-page-address-form, .js-checkout-one-page-payment-form';

let submitGuardRegistered = false;

export function initFormValidation() {
    parsley.initInScope($(document));

    // Abgeschickt wird per Vue (@submit.prevent), Parsley darf diese Formulare nie selbst submitten:
    // Bei asynchronen Validatoren (localDate am DateInput) bricht Parsley den Submit ab und loest
    // ihn nach der Validierung per jQuery erneut aus - das endet in einem nativen form.submit(),
    // also einem GET-Reload mit allen Feldern in der URL.
    parsley.loadParsley().then(() => {
        if (submitGuardRegistered) {
            return;
        }
        submitGuardRegistered = true;
        window.Parsley.on('form:submit', (form) => !form.$element.is(VUE_SUBMITTED_FORMS));
    });
}

// Asynchron, weil validate() bei noch laufenden asynchronen Validatoren null statt true/false liefert
export async function isFormValid(formSelector) {
    await parsley.loadParsley();

    const $form = $(formSelector);
    if (!$form.data('Parsley')) {
        $form.parsley(parsley.options);
    }

    try {
        await $form.data('Parsley').whenValidate();

        return true;
    } catch (e) {
        return false;
    }
}

// Markiert serverseitig abgelehnte Felder (errors: [{field, message}], field = name-Attribut)
// ueber Parsleys eigene addError()-API - dieselbe Technik wie in check-address.js fuer die
// ShipXpert-Adresskorrektur. Dadurch greift extendParsleyAccessibility() (aria-invalid/
// aria-describedby) automatisch mit, genau wie bei Client-seitigen Parsley-Fehlern.
export function setFieldErrors(formSelector, errors) {
    const $form = $(formSelector);
    errors.forEach(({field, message}) => {
        const $field = field ? $form.find(`[name="${CSS.escape(field)}"]`) : $();
        if ($field.length && message) {
            $field.parsley().addError('server', {message, updateClass: true});
        }
    });
}

export function clearFieldErrors(formSelector) {
    const $form = $(formSelector);
    if ($form.data('Parsley')) {
        $form.data('Parsley').reset();
    }
}
